<template>
  <CardViewer
    class="video-viewer"
    :text="text"
    :icon="icon"
    :isFullscreen="true"
    cardClassName="video-card"
    @open="handleOpen()"
  >
    <video class="video-view-content" :src="src" controls controlslist="nodownload"></video>
    <template #fullscreen>
      <video :src="src" controls controlslist="nodownload"></video>
    </template>
  </CardViewer>
</template>

<script>
import { loadVideoNode } from '../utils/common'
import { svgIcons } from '../configs/icon'
import CardViewer from './CardViewer'

export default {
  name: 'app-viewer',
  components: {
    CardViewer,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      icon: svgIcons.video,
    }
  },
  methods: {
    handleOpen() {
      const video = document.querySelector('.video-viewer video')
      loadVideoNode(video, this.src)
    },
  },
}
</script>

<style lang="scss" scoped>
.video-view-content {
  width: 100%;
  height: 618px;
  position: relative;
  z-index: 1;
  border-radius: 10px;
}
</style>